import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import QuestionnaireResults from './QuestionnaireResults';

loadDOMComponent({
	selector: 'react-questionnaire-results',
	callback: ({ container, context, props }: any) => {
		const patientId = container.getAttribute('patientId');
		const questionnaireCode = container.getAttribute('questionnaireCode');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<QuestionnaireResults
							questionnaireCode={questionnaireCode}
							patientId={patientId}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
